import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

import { Cache } from '../../helpers/cache';
import { CacheEntry, MAX_CACHE_AGE } from '../../helpers/cache-entry';;

@Injectable()

export class CacheMapService implements Cache {
  constructor() { }

  cacheMap = new Map<string, CacheEntry>();

  get(req: HttpRequest<any>): HttpResponse<any> | null {
    const entry = JSON.parse(localStorage.getItem(req.url));
    if (!entry) {
      return null;
    }
    const isExpired = (Date.now() - entry.entryTime) > MAX_CACHE_AGE;
    return isExpired ? null : new HttpResponse(entry.response);
  }

  put(req: HttpRequest<any>, res: HttpResponse<any>): void {
    const entry: CacheEntry = { url: req.urlWithParams, response: res, entryTime: Date.now() };
    let cachedata = JSON.stringify(entry);
    localStorage.setItem(req.url, cachedata);
    this.deleteExpiredCache();
  }

  deleteExpiredCache() {
    let keys = Object.keys(localStorage);
    keys.forEach(entry => {
      if (entry != "bg-color" && entry != "logoImage" && entry != "btn-font-color" && entry != "bg-color" && entry != "theme-name" && entry != "tab-font-color" && entry != "tab-color") {
        let data = JSON.parse(localStorage[entry]);
        if ((Date.now() - data.entryTime) > MAX_CACHE_AGE) {
          this.cacheMap.delete(data.url);
        }
      }
    });
  }

}
